import { FileDiff, FilePenLine, ListChecks, Workflow } from 'lucide-react';
import type { FeatureContent } from './types';

export const word: FeatureContent = {
  slug: 'word',
  comingSoon: true,
  navLabel: 'Trovanorma per Word',
  menuDescription:
    'Usa Trovanorma direttamente in Word e inserisci le modifiche come revisioni da accettare o rifiutare.',
  cardDescription:
    'Usa Trovanorma direttamente in Word e inserisci le modifiche nel documento come revisioni da accettare o rifiutare.',
  meta: {
    title: 'Trovanorma per Word',
    description:
      'Porta Trovanorma dentro Word: fai la tua richiesta dal pannello laterale e inserisci la proposta nel documento come revisione tracciata, da accettare o rifiutare.',
  },
  hero: {
    title: 'Trovanorma per Word',
    subtitle:
      'Porta Trovanorma direttamente dentro Word. Fai la tua richiesta dal pannello laterale e inserisci la proposta nel documento come revisione tracciata, pronta da accettare o rifiutare.',
  },
  statement: 'Dal suggerimento al documento, senza copia-incolla',
  statementText:
    'Continua a lavorare nello strumento che usi già: Trovanorma resta accanto al documento, tu mantieni il controllo sul testo finale.',
  blocks: [
    {
      icon: FilePenLine,
      kicker: 'Dentro Word',
      title: 'Trovanorma lavora dove stai già scrivendo',
      description:
        'Apri Trovanorma nel pannello laterale di Word e usa la stessa esperienza di conversazione senza passare continuamente da uno strumento all’altro.',
    },
    {
      icon: FileDiff,
      kicker: 'Revisioni tracciate',
      title: 'Le proposte entrano direttamente nel documento',
      description:
        'Inserisci la risposta di Trovanorma come revisione tracciata, invece di copiarla e incollarla manualmente nel testo.',
    },
    {
      icon: ListChecks,
      kicker: 'Controllo delle modifiche',
      title: 'Decidi tu cosa resta',
      description:
        'Le modifiche passano dagli strumenti di revisione di Word: puoi valutarle e scegliere se accettarle o rifiutarle prima di arrivare al testo definitivo.',
    },
    {
      icon: Workflow,
      kicker: 'Continuità di lavoro',
      title: 'Meno passaggi tra risposta e documento',
      description:
        'Dalla richiesta alla revisione del testo, continui a lavorare in Word senza dover trasferire manualmente il contenuto tra Trovanorma e il documento.',
    },
  ],
  steps: [
    {
      step: 1,
      title: 'Apri Trovanorma in Word',
      description: 'Il pannello laterale porta la chat direttamente accanto al documento.',
    },
    {
      step: 2,
      title: 'Fai la tua richiesta',
      description: 'Continua a confrontarti con Trovanorma mentre lavori sul documento.',
    },
    {
      step: 3,
      title: 'Inserisci e rivedi',
      description:
        'Porta la proposta nel testo come revisione tracciata e decidi in Word quali modifiche mantenere.',
    },
  ],
  relatedSolutions: ['avvocati', 'studi-legali', 'commercialisti'],
  closing: {
    title: 'La risposta non deve fermarsi nella chat',
    text: 'Portala direttamente nel documento come revisione tracciata e decidi tu cosa tenere.',
  },
};
